<template>
  <div>
    <modal-image-viewer-single
      :id="innerID"
      :image-data="previewImage"
    ></modal-image-viewer-single>

    <div class="full-input-group single">
      <b-form-group
        :label="`${title ? title : '上傳文件'}：`"
        label-class="full-label"
        label-for="upload"
        :class="is_required ? 'required' : ''"
      >
        <div id="file-drag-drop">
          <div class="fileform" ref="fileform">
            <!-- image_files = 由選擇檔案上傳的files -->
            <!--  -->
            <div class="file-listing p-2" v-if="previewImage && Object.keys(previewImage).length > 0" >
              <div class="d-flex justify-content-center align-items-center mb-2 ">
                <h4 class="color1 mb-0">檔案已添加</h4>  
                <b-button
                class="ml-1 round-100 bgColor1 p-50 text-12"
                @click="$refs.pickFile.$el.childNodes[0].click()"
                > 更換圖片</b-button>
              </div>
              <div class="d-flex justify-content-center align-items-center">
                <div class="preview-img-wrapper mr-1">
                  <embed
                    v-if="previewImage.type == 'application/pdf'"
                    :src="previewImage.src"
                    class="pdf"
                    type="application/pdf"
                  />
                  <img v-else class="preview" :src="previewImage.src" />
                </div>
                <span class="text mr-1"
                  >{{ previewImage && previewImage.name }}。</span
                >
                <a
                  class="color1"
                  href="javascript:void(0)"
                  @click="beforeSubmitPreview(false)"
                  >preview</a
                >
                <!-- <span class="ml-3">{{ convertSize }}</span> -->

                <!-- <a
                  class="remove ml-2"
                  v-on:click="removeFile"
                >
                  <feather-icon size="18" class="" icon="Trash2Icon" />
                </a> -->
              </div>
            </div>
            <div v-else class="mt-3">
              <font-awesome-icon icon="fa-solid fa-cloud-arrow-up" />
              <p class="colorBlack mt-2 mb-50">選擇檔案或將檔案拖放於此</p>
              <p class="mb">File size no more than 10MB</p>
              <a
                href="javascript:void(0)"
                class="file-button backgroundColor1"
                @click="handleUpload"
                >選擇檔案</a
              >
              <b-button
                v-if="isMobile"
                @click="handleUpload(true)"
                class="ml-1 round-100 bgColor1 p-50"
              >
                <feather-icon icon="CameraIcon" size="16" />
              </b-button>

            </div>
              <b-form-file
                v-model="image_files"
                style="display: none"
                @input="getImagePreviews"
                :capture="capture_check"
                ref="pickFile"
                placeholder="Choose a file or drop it here..."
                drop-placeholder="Drop one file here..."
              ></b-form-file>
            <!-- <div class="file-listing py-1" v-if="(props_previewImage.image_url || props_previewImage.file_url) && !image_files">
              <div class="d-flex exist-item justify-content-center align-items-center">

                <img class="preview mr-1" :src="props_previewImage.file_url || props_previewImage.image_url" />
                
                <div class="preview-img-wrapper">
                      <embed
                        v-if="props_previewImage.type == 'application/pdf'"
                        :src="props_previewImage.file_url"
                        class="pdf"
                        type="application/pdf"
                      />
                      <img v-else class="preview mr-1" :props_previewImage="file.src" />
                    </div>
                <a
                  class="color1"
                  href="javascript:void(0)"
                  @click="beforeSubmitPreview(true)"
                  >preview</a
                >
                <span class="ml-3">{{ props_previewImage.name }}</span>

                <a class="remove ml-2" v-on:click="removeFile(true)">
                  <feather-icon size="18" class="" icon="Trash2Icon" />
                </a>
              </div>
            </div> -->
          </div>
        </div>
      </b-form-group>
    </div>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BFormGroup,
  BButton,
  BFormFile,
  BOverlay,
} from "bootstrap-vue";
import draggable from "vuedraggable";
import ModalImageViewerSingle from "@/layouts/components/file/ModalImageViewerSingle.vue";
import ModalPdf from "@/layouts/components/file/ModalPdf.vue";
import wordIcon from "@/assets/images/icons/file-icons/word.png";
import excelIcon from "@/assets/images/icons/file-icons/excel.png";
import pdfIcon from "@/assets/images/icons/file-icons/pdf.png";
import othersIcon from "@/assets/images/icons/file-icons/others.jpeg";
import { ref, watch } from "@vue/composition-api";
import axiosIns from '@/libs/axios';

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    BFormGroup,
    BFormFile,
    draggable,
    BOverlay,
    ModalPdf,
    ModalImageViewerSingle,
  },
  data() {
    return {
      image_files: null,
      dragAndDropCapable: false,
      capture_check: false,
    };
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    is_required: {
      type: Boolean,
      default: true,
    },
    innerID: {
      type: String,
      default: "-inner",
    },
    file_delete_url: {
      type: String,
      default: "",
    },
    props_previewImage: {},
  },
  methods: {
    handleUpload(capture = false) {
      if (capture) {
        this.capture_check = true;
      } else {
        this.capture_check = false;
      }
      this.$refs.pickFile.$el.childNodes[0].click()
    },
    determineDragAndDrop() {
      var div = document.createElement("div");
      return (
        ("draggable" in div || ("ondragstart" in div && "ondrop" in div)) &&
        "FormData" in window &&
        "FileReader" in window
      );
    },
    getImagePreviews() {
      // check image_files is empty array
      if (this.image_files) {
        // check size > 10MB
        if (this.image_files.size >= 1024 * 1024 * 10) {
          this.$bvToast.toast(`Please drop a file size < 10MB file!`, {
            title: "Error",
            autoHideDelay: 2500,
            variant: "danger",
          });
          this.image_files = null;
        } else {
          let file = this.image_files;
          this.$emit("file-uploaded", file);

          if (
            file.type ==
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          ) {
            // word file ".docx"
            this.previewImage = {
              src: wordIcon,
              type: file.type,
              name: file.name,
            };
          } else if (
            file.type ==
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
            file.type == "application/vnd.ms-excel"
          ) {
            // excel file ".xlsx" and ".xls"
            this.previewImage = {
              src: excelIcon,
              type: file.type,
              name: file.name,
            };
          } else if (file.type == "application/pdf") {
            const fileURL = URL.createObjectURL(file);

            this.previewImage = {
              src: fileURL,
              type: file.type,
              name: file.name,
            };

            // pdf file ".pdf"
            // this.$refs.preview.src = pdfIcon;
          } else if (
            file.type == "image/jpeg" ||
            file.type == "image/jpg" ||
            file.type == "image/png" ||
            file.type == "image/gif" ||
            file.type == "image/webp" ||
            file.type == "image/svg"
          ) {
            /*
            Create a new FileReader object
          */
            let reader = new FileReader();
            //console.log(reader);

            /*
            Add an event listener for when the file has been loaded
            to update the src on the file preview.
          */
            reader.addEventListener(
              "load",
              function () {
                // this.$refs.preview.src = reader.result;
                this.previewImage = {
                  src: reader.result,
                  type: file.type,
                  name: file.name,
                };
              }.bind(this),
              false
            );

            /*
            Read the data for the file in through the reader. When it has
            been loaded, we listen to the event propagated and set the image
            src to what was loaded from the reader.
          */
            reader.readAsDataURL(file);
          } else if (
            file.type != "image/jpeg" &&
            file.type != "image/jpg" &&
            file.type != "image/png" &&
            file.type != "image/gif" &&
            file.type != "image/webp" &&
            file.type != "image/svg"
          ) {
            // files other than images
            this.previewImage = {
              src: othersIcon,
              type: file.type,
              name: file.name,
            };
          }
        }
      }
    },
    removeFile() {
        this.image_files = null;
        this.$emit("file-uploaded", this.image_files);
        this.previewImage = null;
      
    },
    deleteDocument(id) {
      this.$swal({
        title: "你確定嗎?",
        text: "您的決定是最終決定，您將無法取回這記錄。",
        showCancelButton: true,
        confirmButtonText: "刪除",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          axiosIns
            .delete(`${this.file_delete_url}`, { params: {id} })
            .then((response) => {
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.previewImage = null;
            })
            .catch((error) => {
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    beforeSubmitPreview(is_props) {
      // let file = is_props ? this.props_previewImage : this.image_files;
      // console.log("file",file)
      //  if(is_props){
      //   let url = file.image_url || file.file_url
      //   if(url.indexOf(".pdf") > -1){
      //     file.type = "application/pdf"
      //   }else if(url.indexOf(".jpeg") > -1){
      //     file.type = "image/jpeg"
      //   }else if(url.indexOf(".jpg") > -1){
      //     file.type = "image/jpg"
      //   }else if(url.indexOf(".png") > -1){
      //     file.type = "image/png"
      //   }else if(url.indexOf(".gif") > -1){
      //     file.type = "image/gif"
      //   }else if(url.indexOf(".webp") > -1){
      //     file.type = "image/webp"
      //   }else if(url.indexOf(".svg") > -1){
      //     file.type = "image/svg"
      //   }
      //  }

      // this.previewImage = {
      //   src:file.image_url || file.file_url,
      //   type:file.type
      // }
      console.log(`modal-image-viewer-single${this.innerID}`)
      this.$bvModal.show(`modal-image-viewer-single${this.innerID}`);
    },
  },
  computed: {
    convertSize() {
      var size;
      if (this.image_files) {
        size = this.image_files.size;
        const calc = size / (1024 * 1024);

        return calc > 0.1
          ? calc.toFixed(2) + "MB"
          : (calc * 1024).toFixed(2) + "KB";
      } else {
        return 0 + "KB";
      }
    },
    isMobile(){
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }
  },
  mounted() {
    /*
      Determine if drag and drop functionality is capable in the browser
    */
    this.dragAndDropCapable = this.determineDragAndDrop();
    /*
      If drag and drop capable, then we continue to bind events to our elements.
    */
    /*
        Listen to all of the drag events and bind an event listener to each
        for the fileform.
      */

    [
      "drag",
      "dragstart",
      "dragend",
      "dragover",
      "dragenter",
      "dragleave",
      "drop",
    ].forEach(
      function (evt) {
        /*
              For each event add an event listener that prevents the default action
              (opening the file in the browser) and stop the propagation of the event (so
              no other elements open the file in the browser)
          */
        this.$refs.fileform.addEventListener(
          evt,
          function (e) {
            e.preventDefault();
            e.stopPropagation();
          }.bind(this),
          false
        );
      }.bind(this)
    );

    /*
          Add an event listener for drop to the form
        */
    this.$refs.fileform.addEventListener(
      "drop",
      function (e) {
        /*
            Capture the files from the drop event and add them to our local files
            array.
          */
        if (e.dataTransfer.files.length > 1) {
          this.$bvToast.toast(`Please drop only one file!`, {
            title: "Error",
            autoHideDelay: 2500,
            variant: "danger",
          });
          e.dataTransfer.files = [];
          this.image_files = null;
        } else if (e.dataTransfer.files[0].size >= 1024 * 1024 * 10) {
          this.$bvToast.toast(`Please drop a file size < 10MB file!`, {
            title: "Error",
            autoHideDelay: 2500,
            variant: "danger",
          });
          e.dataTransfer.files = [];
          this.image_files = null;
        } else {
          // image files = the dropped files
          this.image_files = e.dataTransfer.files[0];
          this.getImagePreviews();
        }
      }.bind(this)
    );
  },
  setup(props) {
    const previewImage = ref([]);
    watch(
      () => props.props_previewImage,
      (newVal) => {
        console.log("newVal",newVal)
        if (newVal) {
          var url = newVal.file_url ? newVal.file_url : newVal.image_url;
          var path = newVal.file_path ? newVal.file_path : newVal.image_path;
          previewImage.value = {
            id: newVal.id,
            name: newVal.name,
            src: url,
            type: path.indexOf("pdf") > -1 ? "application/pdf" : "image/jpeg",
            is_exist: 1,
          };
        } else {
          previewImage.value = {};
        }
        console.log("previewImage",previewImage.value)
      },
      { immediate: true }
    );

    return {
      previewImage,
    };
  },
};
</script>

<style>
.single div.file-listing img {
    height: 150px;
}
</style>